import { API_CONFIG } from '../config/api';
import { STORAGE_KEYS } from '../config/api';

class ApiService {
  constructor() {
    this.baseURL = API_CONFIG.BASE_URL;
    this.apiKey = API_CONFIG.API_KEY;
  }

  getHeaders(includeAuth = false) {
    const headers = {
      'Content-Type': 'application/json',
      'X-API-Key': this.apiKey
    };

    if (includeAuth) {
      const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return headers;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const config = {
      ...options,
      headers: this.getHeaders(options.auth)
    };

    try {
      const response = await fetch(url, config);
      
      // Tentar parsear JSON
      let data;
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        data = await response.json();
      } else {
        const text = await response.text();
        data = { error: text || 'Erro desconhecido' };
      }

      if (!response.ok) {
        throw new Error(data.error || data.message || 'Erro na requisição');
      }

      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  async get(endpoint, auth = false) {
    return this.request(endpoint, { method: 'GET', auth });
  }

  async post(endpoint, body, auth = false) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(body),
      auth
    });
  }

  async put(endpoint, body, auth = false) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(body),
      auth
    });
  }

  async delete(endpoint, auth = false) {
    return this.request(endpoint, {
      method: 'DELETE',
      auth
    });
  }
}

export default new ApiService();
